<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn class="mr-1 ml-1" color="primary" text dark v-on="on">
        <v-icon small class="mr-1">fa-plus</v-icon>Add Material
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in trainingMaterialOptions"
        :key="index"
        @click="showPanel(index)"
      >
        <v-list-item-title class="text-left">{{
          item.title
        }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import AddAICC from '@/components/admin/course/trainingmaterial/Aicc';
import AddDocument from '@/components/admin/course/trainingmaterial/Document';
import AddSCORM from '@/components/admin/course/trainingmaterial/Scorm';
import AddVideo from '@/components/admin/course/trainingmaterial/Video';
import ExternalLink from '@/components/admin/course/trainingmaterial/ExternalLink';
import AddPowerPoint from '@/components/admin/course/trainingmaterial/Powerpoint';
export default {
  data() {
    return {
      trainingMaterialOptions: [
        { title: 'Video' },
        { title: 'Document' },
        { title: 'External Link' },
        { title: 'Powerpoint Player' },
        //{ title: "SCORM File" },
        //{ title: "AICC file" },
        //{ title: "xAPI file" }
      ],
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  methods: {
    showPanel(id) {
      switch (id) {
        case 0:
          this.showAddVideoPanel();
          break;
        case 1:
          this.showAddDocumentPanel();
          break;
        case 2:
          this.showExternalLinkPanel();
          break;
        case 3:
          this.showAddPowerPointPanel();
          break;
        case 4:
          break;
        default:
          break;
      }
    },
    /*
    showAddAICCPanel() {
      this.$showPanel({
        component: AddAICC,
        props: {
          id: this.id
        }
      });
    },
    */
    showAddDocumentPanel() {
      this.$showPanel({
        component: AddDocument,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    /*
    showAddSCORMPanel() {
      this.$showPanel({
        component: AddSCORM,
        props: {
          id: this.id
        }
      });
    },
    */
    showAddVideoPanel() {
      this.$showPanel({
        component: AddVideo,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    showExternalLinkPanel() {
      this.$showPanel({
        component: ExternalLink,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    showAddPowerPointPanel() {
      this.$showPanel({
        component: AddPowerPoint,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
  },
};
</script>
